export default __webpack_public_path__ + "static/media/training_video_poster.d97627eb.jpg";